import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>PRECISION AGRICULTURE </h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                 We harness IoT, AI, and automation to empower farmers with intelligent solutions that optimize yield, resource utilization, and crop health. Our offerings include soil moisture sensors, drone-based imaging, automated irrigation control, and crop monitoring platforms. These technologies allow for data-driven decisions, reduce environmental impact, and improve farm productivity.{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-light">
         <Container>
           <Row className="text-center">
             {/* Feature 1 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
               <i className="bi bi-noise-reduction fa-3x mb-3 text-secondary"></i>
               <hr className="my-3" />
              <h5>Soil Moisture Sensing</h5>
               <div className="btSubTitle small">
                 Real-time monitoring of soil conditions to optimize irrigation schedules and conserve water.
               </div>
              
             </Col>
       
             {/* Feature 2 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
               <i className="bi bi-droplet fa-3x mb-3 text-info"></i>
               <hr className="my-3" />
               <h5>Automated Irrigation</h5>
               <div className="btSubTitle small">
                IoT-driven irrigation systems that automatically adjust water flow based on real-time soil and weather data.
               </div>
             
             </Col>
       
             {/* Feature 3 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
               <i className="bi bi-crop fa-3x mb-3 text-danger"></i>
               <hr className="my-3" />
               <h5>Crop Monitoring Platforms</h5>
               <div className="btSubTitle small">
                Centralized dashboards for monitoring crop growth, predicting diseases, and analyzing trends with AI.
               </div>
               
             </Col>
           </Row>
           <br />
           <Row className="text-center">
             {/* Feature 1 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
               <i class="bi bi-cloud fa-3x mb-3 text-warning"></i>
               <hr className="my-3" />
               <h5>Weather-Linked Analytics</h5>
               <div className="btSubTitle small">
                Integrated weather forecasting for smarter planting, fertilizing, and harvesting decisions.
               </div>
             
             </Col>
       
             {/* Feature 2 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
               <i className="bi bi-clipboard2-data fa-3x mb-3 text-secondary"></i>
               <hr className="my-3" />
               <h5>Data-Driven Insights</h5>
               <div className="btSubTitle small">
              Big data and AI models that turn raw agricultural data into actionable farming strategies.
               </div>
              
             </Col>
       
             
           </Row>
         </Container>
       </section>

        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
